<template>
    <div>
        <a-card>
            <div class="text-center" style="margin: 40px 0" v-if="pageList.length === 0">
                <img style="margin: auto;width: 90px" src="../../img/empty1.png">
                <p class="size2 mt-3 color-ash">无需缴纳保证金</p>
            </div>
            <div class="size6 text-center m-5" style="position: relative;z-index: 999" v-if="pageList.length > 0" >
                <span>投标保证金帐号及缴退情况</span>
                <div class="d-inline-block b" style="position: relative;">
                    <a-icon class="color-ash size4 pl-3 pr-3 b" type="question-circle"/>
                    <div class="doubt">
                        <div class="bold color-black">关于投标保证金电子化管理的有关说明</div>
                        <p>广东志正招标有限公司与中国农业银行合作，实现对供应商投标保证金的电子化管理，提升保证金收退效率，减少人工错误。</p>
                        <p>投标保证金帐号的管理原则为“一供应商一项目包组一保证金帐号”，每个供应商在项目报名成功后，农行为每个供应商实时生成一个<span class="color-red">一次性使用</span>的保证金缴纳帐号。也就是说：<span class="color-red">不同的供应商在同一个项目包组里的保证金缴纳帐号是不同的；而同一个供应商在不同的项目包组里保证金缴纳帐号也是不同的</span>。请广大供应商仔细阅读并理解上述原则，勿错缴、漏缴保证金，从而影响投标。</p>
                        <p>保证金缴纳帐号为农行二级子账簿，帐号长度为27位。</p>
                        <p>保证金缴纳帐号生成后，快采平台会通过手机短信通知供应商项目联系人登录快采平台查看保证金缴纳帐号，请各供应商在开标前足额缴纳投标保证金，否则将失去投标资格。</p>
                    </div>
                </div>
            </div>
            <a-row v-if="pageList.length > 0">
                <a-col :span="18" :offset="3">

                    <table class="fx-form-view" >
                        <template  v-for="it in pageList">
                        <tr>
                            <th colspan="2" class="text-center">{{it.packsAlisName}} ：{{it.packsName}}</th>
                        </tr>
                        <tr>
                            <th>账号信息</th>
                            <td>
                                <div>应交金额：<span class="color-red">{{it.bondMoney}}元</span></div>
                                <div>缴款账号请参照竞价文件</div>
<!--                                <div>银行名称：{{it.bank}}</div>-->
<!--                                <div>银行账户：{{it.mergeAccno}}</div>-->
<!--                                <div>企业名称：{{it.supplierName}}</div>-->
                            </td>
                        </tr>
                        <tr>
                            <th>缴退情况</th>
                            <td>
                                <span v-if="it.state === '0'" class="color-red">
                                    未缴纳
                                </span>
                                <span v-if="it.state === '1'">
                                    已缴纳
                                </span>
                                <span v-else-if="it.state === '2'">
                                    余额不足
                                </span>
                                <span v-else-if="it.state === '3'">
                                    已退定
                                </span>
                            </td>
                        </tr>
                        </template>
                    </table>
                        <br>

                </a-col>
            </a-row>

        </a-card>
    </div>
</template>

<script>
    export default {
        props:{
            projectId: {
                type:String,
                required: true
            },
            random: {
                type:String,
                default: '',
                required: false
            }
        },
        watch: {
            random: {
                immediate: false,
                handler(newValue,oldValue) {
                    if (newValue !== oldValue) {
                        // console.log("has listened data!")
                        this.initData();
                    }
                }
            }
        },
        created() {
            this.initData();
        },
        name: "BondInfo",
        data() {
            return {
                bondList:[],
                current:1,
                pageList:[]
            }
        },
        methods: {
            initData() {
                let that = this
                this.$http.get('/api/v1/supplier/bond/get_list.json?projectId='+this.projectId).then(function (res) {
                    that.bondList = res.result
                    that.onChangePage(1)
                });
            },
            onChangePage(current) {
                this.current = current
                // 获取索引
                var index = (this.current - 1) * 5
                this.pageList = []
                for (let i = index; i < index + 5; i++) {
                    var datum = this.bondList[i]
                    if (datum) {
                        this.pageList.push(datum)
                    }
                }
            }
        }
    }
</script>

<style scoped>
    /deep/ .ant-tooltip-arrow::before {
        display: none !important;
    }
    .d-inline-block.b:hover > .doubt{
        opacity: 1;
        visibility: initial;
        transform: translateY(0);
    }
    .doubt{
        position: absolute;
        background: #fff;
        width: 400px;
        font-size: 14px;
        box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.2);
        padding: 12px;
        opacity: 0;
        transform: translateY(-20px);
        transition: all .3s;
        visibility: hidden;
    }
    .doubt::before {
        position: absolute;
        display: inline-block;
        top: -6px;
        left: 16px;
        width: 0;
        height: 0;
        content: '';
        border-style: solid;
        border-width: 6px;
        border-color: transparent transparent #fff #fff;
        -webkit-transform: rotate(135deg);
        transform: rotate(135deg);
        -webkit-box-shadow: -4px 5px 6px rgba(0, 0, 0, 0.2);
        box-shadow: -3px 2px 6px rgba(0, 0, 0, 0.07);
    }
    .doubt p{
        font-size: 12px;
        margin: 0;
        line-height: 20px;
        text-align: justify;
        text-indent: 24px;
    }
    .fx-form-view {
        table-layout: auto;
    }
    .fx-form-view th {
        border: 1px solid #e6e6e6;
        background-color: #f9f9f9;
    }
    .fx-form-view td {
        border: 1px solid #e6e6e6;
    }
</style>
